import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    if (!isHome) {
      setScrolled(true);
      return;
    }
    const handleScroll = () => setScrolled(window.scrollY > 60);
    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isHome]);

  const navLinks = [
    { label: 'About', href: '/about' },
    { label: 'Services', href: '/services' },
    { label: 'Outcomes', href: '/outcomes' },
    { label: 'For Agencies', href: '/for-agencies' },
    { label: 'Careers', href: '/careers' },
    { label: 'Contact', href: '/contact' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70 py-3'
          : 'bg-transparent py-5'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 group">
          <span className={`heading-font text-2xl font-bold transition-colors duration-500 ${
            scrolled ? 'text-foreground-900' : 'text-white'
          }`}>
            MCT
          </span>
          <span className={`hidden sm:inline text-sm font-medium transition-colors duration-500 label-font ${
            scrolled ? 'text-foreground-600' : 'text-white/80'
          }`}>
            Residential Services
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              className={`text-sm font-medium whitespace-nowrap transition-colors duration-300 label-font ${
                scrolled
                  ? location.pathname === link.href
                    ? 'text-primary-600'
                    : 'text-foreground-700 hover:text-primary-600'
                  : 'text-white/80 hover:text-white'
              }`}
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/contact"
            className={`px-5 py-2.5 rounded-full text-sm font-semibold whitespace-nowrap transition-all duration-300 label-font ${
              scrolled
                ? 'bg-primary-500 text-white hover:bg-primary-600'
                : 'bg-white text-foreground-900 hover:bg-white/90'
            }`}
          >
            Request Placement
          </Link>
        </div>

        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className={`md:hidden w-10 h-10 flex items-center justify-center rounded-md transition-colors ${
            scrolled ? 'text-foreground-900' : 'text-white'
          }`}
          aria-label="Toggle menu"
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-4 flex flex-col gap-3">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                onClick={() => setMobileOpen(false)}
                className={`text-sm font-medium py-2 label-font transition-colors ${
                  location.pathname === link.href ? 'text-primary-600' : 'text-foreground-700 hover:text-primary-600'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/contact"
              onClick={() => setMobileOpen(false)}
              className="bg-primary-500 text-white text-sm font-semibold py-3 rounded-full text-center label-font hover:bg-primary-600 transition-colors mt-2"
            >
              Request Placement
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}